export default class Menu {
  /*
   * Open Menu Mobile
   * */
  public static openMenu(
    eltOpenMenu: HTMLElement,
    eltMenu: HTMLElement,
    openMenuClass: string,
    preventDefault = false
  ): void {
    if (eltOpenMenu) {
      eltOpenMenu.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();

          if (preventDefault) {
            event.preventDefault();
          }

          if (!eltMenu.classList.contains(openMenuClass)) {
            // Assign lock to html element
            document.documentElement.classList.add('is-locked');

            eltMenu.classList.add(openMenuClass);

            // block pointer events
            eltMenu.addEventListener('pointermove', (e) => {
              e.preventDefault();
            });
          }
        },
        { passive: !preventDefault }
      );

      window.addEventListener('resize', Menu.syncHeight, {
        passive: true,
      });
    }
  }

  /*
   * Close Menu Mobile
   * */
  public static closeMenu(
    closeMenus: NodeListOf<HTMLElement>,
    eltMenu: HTMLElement,
    openMenuClass: string,
    openSubMenuClass = ''
  ) {
    const arrayCloseMenus: Array<HTMLElement> = Array.from(closeMenus);

    arrayCloseMenus.forEach((closeMenuElt: HTMLElement) => {
      closeMenuElt.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();

          if (eltMenu.classList.contains(openMenuClass)) {
            // Remove lock from html element
            document.documentElement.classList.remove('is-locked');

            // Resume pointer events
            eltMenu.removeEventListener('pointermove', (e) => {
              e.preventDefault();
            });

            // Close menu
            eltMenu.classList.remove(openMenuClass);

            if (openSubMenuClass !== '') {
              // Back to menu
              Array.from(document.querySelectorAll('.js-openSubMenu')).map(
                (subMenu) => subMenu.classList.remove(openSubMenuClass)
              );
            }
          }
        },
        { passive: true }
      );
    });
  }

  /*
   * Get height window
   * */
  private static syncHeight() {
    document.documentElement.style.setProperty(
      '--window-inner-height',
      `${window.innerHeight}px`
    );
  }
}
